import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { tap } from 'rxjs';
import { SKIP_HTTP_ERROR } from '../../transloco-loader';
import { TranslocoService } from '@ngneat/transloco';
import { ToastService } from '../services/toast/toast.service';
import { AuthService } from '../services/auth/auth.service';

export const httpErrorInterceptor: HttpInterceptorFn = (req, next) => {
    const toastService = inject(ToastService);
    const authService = inject(AuthService);
    const translocoService = inject(TranslocoService);

    if (req.context.get(SKIP_HTTP_ERROR)) {
        return next(req);
    }

    return next(req).pipe(
        tap({
            error: (errorHttpResponse) => {
                handleHttpErrors(errorHttpResponse, toastService, authService, translocoService);
            }
        })
    );

    async function handleHttpErrors(
        httpResponse: any,
        toastService: ToastService,
        authService: AuthService,
        translocoService: TranslocoService
    ): Promise<void> {
        switch (httpResponse.status) {
            case 401:
                toastService.toastWarning(translocoService.translate('backend-errors.not-authorized'));
                await authService.logout();
                break;

            case 403:
                toastService.toastWarning(translocoService.translate('backend-errors.method-not-allowed'));
                break;

            case 400: {
                let errorMessage = translocoService.translate('backend-errors.bad-request');
                if (httpResponse.error?.errors) {
                    errorMessage = httpResponse.error.errors.join('\r\n');
                }
                toastService.toastWarning(`Ops! ${errorMessage}`);
                break;
            }

            case 500:
                if (httpResponse.error?.errors?.length) {
                    httpResponse.error.errors.forEach((err: string) =>
                        toastService.toastError(err)
                    );
                } else {
                    toastService.toastError(
                        translocoService.translate('backend-errors.internal-server-error')
                    );
                }
                break;

            default:
                toastService.toastError(
                    translocoService.translate('backend-errors.default') +
                    (httpResponse.error?.message || '')
                );
        }
    }

};